import React, {useEffect} from "react";
import "./TransactionCompleted.style.scss";
import PropTypes from "prop-types";
import {_t} from "../../../../../utils/I18nUtils";
import {useDispatch} from "react-redux";

const TransactionCompleted = ({vm})=>{

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(trackEvent('AddFundsSuccess'));
    }, []);

    return <div className="TransactionCompleted">
        <h2 className="text-center"><i className="fa fa-fw fa-check-circle"
                                       style={{color: '#00b86f'}}/> {_t(`views.addFundView.fundsAdded`)}</h2>
        <br/>
        <div className="buttonsBar text-center">
            <a onClick={()=>vm.handleOrderConfirmedOkClick()}
               className="btn btn-primary btn-md">{_t(`views.addFundView.closeBtn`)}</a>
        </div>
    </div>
};

TransactionCompleted.propTypes = {
    vm: PropTypes.object
};

export default TransactionCompleted;